import '.ak{position:relative;}.ssr-plugin'
import '.c8{display:inline-flex;}.ssr-plugin'
import '.aj{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.b8{position:absolute;}.ssr-plugin'
import '.c9{top:-6px;}.ssr-plugin'
import '.ca{right:-6px;}.ssr-plugin'
import '.cb{min-width:1.125rem;}.ssr-plugin'
import '.cc{height:1.125rem;}.ssr-plugin'
import '.cd{padding:0 0.125rem;}.ssr-plugin'
import '.ce{border-radius:100%;}.ssr-plugin'
import '.cf{border:2px solid var(--palette-white);}.ssr-plugin'
import '.cg{background:var(--brand-primary);}.ssr-plugin'
import '.n{color:var(--palette-white);}.ssr-plugin'
import '.ch{font-size:0.625rem;}.ssr-plugin'
import '.ci{font-weight:700;}.ssr-plugin'
import '.cj{line-height:0.8725rem;}.ssr-plugin'
import '.bm{text-align:center;}.ssr-plugin'
import '.ck{pointer-events:none;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type IconDefinition } from '@fortawesome/pro-solid-svg-icons'

export type IconButtonProps = {
  variant?: Variant
  size?: Size
  shape?: Shape
  icon: IconDefinition
  disabled?: boolean
  style?: Style
  onClick: () => void
  notification?: number
}

type Size = 'medium' | 'small'
type Variant = 'primary' | 'secondary' | 'transparent'
type Shape = 'square' | 'circle'

const sizeStyle: Record<Size, Style> = {
  medium: {
    width: '3rem',
    height: '3rem',
    padding: '0.625rem',
    aspectRatio: '1/1',
    fontSize: '1.125rem',
  },
  small: {
    width: '2rem',
    height: '2rem',
    padding: '0.25rem',
    aspectRatio: '1/1',
    fontSize: '0.875rem',
  },
}

const shapeStyle: Record<Shape, Style> = {
  square: { borderRadius: '0.625rem' },
  circle: { borderRadius: '50%' },
}

const variantStyle: Record<Variant, Style> = {
  primary: {
    color: 'var(--palette-white)',
    background: 'var(--brand-primary)',
    border: '2px solid var(--brand-primary)',
    '&:hover': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:active': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:disabled': {
      background: 'var(--palette-red-200)',
      border: '2px solid var(--palette-red-200)',
    },
  },
  secondary: {
    color: 'var(--brand-secondary)',
    background: 'var(--gray-100)',
    border: '2px solid var(--gray-100)',
    '&:hover': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
  transparent: {
    color: 'var(--brand-secondary)',
    background: 'transparent',
    border: '2px solid var(--brand-secondary)',
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
}

export const IconButton = ({
  variant = 'primary',
  size = 'medium',
  shape = 'square',
  icon,
  disabled = false,
  style,
  onClick,
  notification,
}: IconButtonProps) => {
  return (
    <div className="ak c8">
      <styled.button className="c8 aj r z"
        disabled={disabled}
        onClick={onClick}
        style={{
          '&:hover:disabled': {
            cursor: 'not-allowed',
          },
          ...variantStyle[variant],
          ...sizeStyle[size],
          ...shapeStyle[shape],
          ...style,
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ width: '100%', height: '100%' }}
        />
      </styled.button>
      {notification > 0 && (
        <span className="b8 c9 ca cb cc cd ce cf cg n ch ci cj bm ck"
        >
          {notification}
        </span>
      )}
    </div>
  )
}
